import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "", as = "span" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.1, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, y = 48, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ index, title, testId }) => (
  <FadeUp className="mb-16 md:mb-24">
    <div className="flex items-baseline justify-between border-b border-white/15 pb-6" data-testid={testId}>
      <span className="text-xs tracking-[0.3em] uppercase text-ash">{index}</span>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight uppercase font-bold">{title}</h2>
    </div>
  </FadeUp>
);
